import React, {Component} from 'react';
import Styles from './style.css';
import {Link} from 'react-router-dom';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from 'query-string';
import cx from "classnames";
import HeaderMobileMenu from "../header-mobile-menu/component";
import {marketRegister} from "../../services/marketRegister";
import {demoRegister} from "../../services/demoRegister";
import ModalVideo from "../modal-video/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class HeaderHomeOne extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            lang: null,
            dropwdown: false,
            languages: [],
            video: false
        };
        this.child = React.createRef();
        this._setVideo = this._setVideo.bind(this);
    };

    componentWillMount() {
        this._updateUser();
        this._updateLang();
        this._updateLanguages();
    }

    _updateLang(){
        this.setState({lang: langRegister.lang()});
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            });
        }
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get("languages"));
        this.setState({languages: languages});
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _login() {

        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }

        /*
        let query = queryString.parse(this.props.props.location.search);
        if(query.from_path){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login?from_path=" + query.from_path);
        }else if(query.to){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login?from_path=" + query.to);
        }else{
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login");
        }
        */
    }

    _signout() {
        userRegister.remove();
        tokenRegister.remove();
        demoRegister.remove();
        window.location.reload();
    }

    _openMenu() {
        this.child._openMenu();
    }

    _profile() {
        /*
        try {
            this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
        } catch (e) {}
        */
    }

    _home() {
        try {
            this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/");
        } catch (e) {
        }
    }

    _setLang(prop){
        langRegister.set(prop);
        this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang());
        window.location.reload();
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _renderText(item) {
        return langRegister.get("home-header-one", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.dropwdown &&
                    <div onClick={() => this.setState({dropwdown: false})} className={Styles.languageButtonContainerOverlay}/>
                }
                {
                    this.state.video &&
                    <ModalVideo setVideo={this._setVideo} props={this.props}/>
                }
                <div className={Styles.header}>
                    {
                        this.state.dropwdown &&
                        <div onClick={() => this.setState({dropwdown: false})} className={Styles.languageButtonContainerOverlay}/>
                    }
                    <div className={Styles.logoContainer}>
                        <img onClick={() => this._home()} className={Styles.logoContainerIcon}
                             src={require("../../assets/images/logo.svg")}/>
                        <img onClick={() => this._home()} className={Styles.logoContainerIconMobile}
                             src={require("../../assets/images/logo_mobile.svg")}/>
                    </div>
                    <div className={Styles.menuContainer}>
                        <div className={Styles.menuContainerInner}>
                            <div onClick={() => this._scrollTo('howto')} className={Styles.menuContainerItem}>
                                {this._renderText("item_1")}
                            </div>
                            <div onClick={() => this._setVideo(true)} className={Styles.menuContainerItem}>
                                {this._renderText("item_2")}
                            </div>
                            <div onClick={() => this._scrollTo('benefits')} className={Styles.menuContainerItem}>
                                {this._renderText("item_3")}
                            </div>
                            <div onClick={() => this._scrollTo('features')} className={Styles.menuContainerItem}>
                                {this._renderText("item_4")}
                            </div>
                            <div onClick={() => this._scrollTo('faq')} className={Styles.menuContainerItem}>
                                {this._renderText("item_5")}
                            </div>
                        </div>
                    </div>
                    {
                        this.state.user.email && !this.state.user.reseller && !this.state.user.inhouse &&
                        <div onClick={() => this._profile()} className={Styles.buttonContainerUserDesktop}>
                            <img className={Styles.buttonContainerUserDesktopIcon}
                                 src={require("../../assets/images/user_icon.svg")}/>
                        </div>
                    }
                    {
                        this.state.user.email && (this.state.user.reseller || this.state.user.inhouse) &&
                        <div onClick={() => this._profile()} className={Styles.buttonContainerUserDesktop}>
                            <img className={Styles.buttonContainerUserDesktopIcon} src={require("../../assets/images/user_icon_reseller.svg")}/>
                        </div>
                    }
                    <div className={Styles.languageButtonContainer}>
                        <div className={Styles.languageButtonContainerInner}>
                            <div onClick={() => this.setState({dropwdown: !this.state.dropwdown})} className={Styles.buttonContainerLanguage}>
                                {this.state.lang}
                            </div>
                            {
                                this.state.dropwdown &&
                                <div>
                                    <div className={Styles.languageButtonDropdown}>
                                        {
                                            this.state.languages.map((item) => {
                                                return(
                                                    <div onClick={() => this._setLang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                        {item.names[langRegister.lang()]}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className={Styles.languageButtonTriangle}/>
                                </div>
                            }
                        </div>
                    </div>
                    {
                        !this.state.user.email &&
                        <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_7")}
                        </div>
                    }
                    {
                        this.state.user.email &&
                        <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_6")}
                        </div>
                    }
                    {
                        this.state.user.email && !this.state.user.reseller && !this.state.user.inhouse &&
                        <img onClick={() => this._profile()} className={Styles.buttonContainerUserIcon}
                             src={require("../../assets/images/user_icon.svg")}/>
                    }
                    {
                        this.state.user.email && (this.state.user.reseller || this.state.user.inhouse) &&
                        <img onClick={() => this._profile()} className={Styles.buttonContainerUserIcon}
                             src={require("../../assets/images/user_icon_reseller.svg")}/>
                    }
                    <span className={Styles.mobileMenu}>
                       <HeaderMobileMenu props={this.props.props} ref={instance => {
                           this.child = instance;
                       }}/>
                </span>
                    <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                         src={require("../../assets/images/menu_icon.svg")}/>
                </div>
            </div>
        );
    }
}

/*
<div className={Styles.buttonContainer}>
                    {
                        this.state.user &&
                        <div onClick={() =>this._profile()} className={Styles.buttonContainerUserDesktop}>
                            <img className={Styles.buttonContainerUserDesktopIcon} src={require("../../assets/images/user_icon.svg")}/>
                        </div>
                    }
                    <div onClick={() => this._setLang()} className={Styles.buttonContainerLanguage}>
                        {this.state.lang}
                    </div>
                    {
                        !this.state.user &&
                        <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_7")}
                        </div>
                    }
                    {
                        this.state.user &&
                        <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                            {this._renderText("item_6")}
                        </div>
                    }
                    {
                        this.state.user &&
                        <img onClick={() =>this._profile()} className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon.svg")}/>
                    }
                    <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                         src={require("../../assets/images/menu_icon.svg")}/>
                </div>
 */

export default HeaderHomeOne;


// WEBPACK FOOTER //
// ./src/components/header-home-one/component.js